<ng-container>
    <ng-form #form="ngForm">

        @if (currentStepName === 'account') {
        @if (shouldLogin()) {
        <h3 class="left flex flex-middle">
            <i class="icon-account inline-block fs-8"></i>
            <span class="s1 col-1 m-l-3"><span>{{'Welcome back' | translate}}</span>,
                {{checkResult.name}}</span>
        </h3>
        }
        @if (shouldRegister()) {
        <div class="w-12">
            <h1 class="left flex flex-middle"><i class="icon-account inline-block fs-8"></i>
                <span class="s1 col-1 m-l-3">{{'Welcome' | translate}}</span>
            </h1>
        </div>
        <div class="w-12">
            <div class="w-1">
            </div>
            <div class="p2 col-12 left">{{'You can create an account after checkout.' | translate}}
            </div>
        </div>
        }
        @if (!shouldLogin() && !shouldRegister()) {
        <!-- page title -->
        <h1 class="left flex flex-middle">
            <i class="icon-account inline-block fs-8"></i>
            <span class="s1 col-1 m-l-3">{{'Contact' | translate}}</span>
        </h1>
        }
        }

        <!-- email address -->
        <input-wrap class="block m-t-6 left p1">
            @if (isLoggedIn) {
            <input class="w-12 input is-disabled"
                   [value]="checkoutFormComponent.email"
                   disabled />
            }
            @if (!isLoggedIn) {
            <input class="input"
                   type="email"
                   maxlength="100"
                   validatePattern="email"
                   [loqateEmail]="shouldRegister()"
                   name="email"
                   [attr.placeholder]="'Email address' | translate"
                   [muiInput]="'Email'"
                   [muiInputValidateOnSubmit]="!shouldRegister()"
                   required
                   email
                   #emailInput
                   autocomplete="username"
                   [(ngModel)]="tmpEmail"
                   (ngModelChange)="applyTmpEmail()"
                   (blur)="applyTmpEmail(true)"
                   (keyup.enter)="applyTmpEmail(true)">
            }
        </input-wrap>

        <!-- logout -->
        @if (isLoggedIn) {
        <div class="m-t m-b left">
            <div class="s1 p-b-2">{{'Not you?' | translate}}</div>
            <span class="m-t-2 m-b">
                <action class="button-inline"
                        type="button"
                        [status]="logoutStatus"
                        (click)="logout()">
                    <span class="p2">{{'Click here' | translate}}</span>
                </action>&nbsp;
                <span class="p2">{{'to logout (Items in your basket will be kept).' | translate}}
                </span>
            </span>
        </div>
        }

        <!-- guest -->
        @if (isGuestCheckout) {
        <div class="m-t-6 m-b left">
            <p class="s1">{{'You are using guest checkout.' | translate}}</p>
            <div class="m-t-2">
                <action class="button-inline"
                        type="button"
                        (click)="leaveGuestCheckout()">
                    <span class="p2">{{'Click here' | translate}}</span>
                </action>&nbsp;
                <span class="p2">{{'if you want to sign in.' | translate}}</span>
            </div>
        </div>
        }

        <!-- if should login : login form -->
        @if (shouldLogin()) {
        <p class="p2 left m-t-6 m-b-6">{{'Please enter your password' | translate}}</p>
        <!-- password input -->
        <input-wrap class="w-12 password-input">
            <input class="input"
                   type="password"
                   name="password"
                   [attr.placeholder]="'Enter password'"
                   required
                   [muiInput]="'Password'"
                   [(ngModel)]="data.password"
                   (keyup.enter)="login(onLoginSuccess)">
        </input-wrap>
        <!-- reset my password -->
        <div class="m-t-1 right">
            <action class="cursor-pointer"
                    [status]="passwordStatus"
                    sl-button="reset"
                    (click)="resetPassword()"><span class="p2 col-12">{{'Forgotten password?' | translate}}</span>
            </action>
            <result class="m-t-2 block col-3 c2"
                    [status]="passwordStatus"
                    sl-result="reset"
                    [success]="'We`ve sent you an email with a link to reset your password.' | translate"></result>
        </div>
        <!-- newsletter signup -->
        @if (!customer.model.data.newsletter) {
        <input-wrap class="m-t-3 block">
            <span class="flex flex-middle w-12">
                <i class="icon-email inline-block fs-8"></i>
                <span class="p1 col-1 m-l-2">{{'Sign up to our newsletter' | translate}}</span>
            </span>
            <radio-group class="block m-t-6 p-t-1 left col-12"
                         name="newsletter"
                         [value]="newsletterPreselection"
                         [(ngModel)]="checkoutFormComponent.data.newsletter">
                <div class="w-4 w-6-s left">
                    <radio value="1"><span class="p-l-2">{{'Yes, please' | translate}}</span></radio>
                </div>
                <div class="w-4 w-6-s left">
                    <radio [value]="undefined"><span class="p-l-2">{{'No, thanks' | translate}}</span></radio>
                </div>
            </radio-group>
        </input-wrap>
        }
        <!-- action button -->
        <div class="m-t p-t">
            <action class="w-12 button"
                    type="button"
                    [status]="loginStatus"
                    sl-button="login"
                    (click)="login(onLoginSuccess)"><span>{{'Login' | translate}}</span></action>
        </div>
        <!-- continue button -->
        <action class="w-12 m-t-3 button-1"
                type="button"
                (click)="continueAsGuestToDelivery()"><span>{{'Continue as guest' | translate}}</span></action>
        <div class="w-12">
            <!-- notifications -->
            <result class="c1 m-t-2 block col-2"
                    sl-result="login"
                    [status]="loginStatus"></result>
        </div>
        }

        <!-- if should registr : create account form -->
        @if (shouldRegister()) {
        <!-- first name -->
        <input-wrap class="m-t-3 block">
            <input class="input"
                   type="text"
                   name="firstname"
                   [muiInput]="'First name'"
                   validatePattern="name"
                   maxlength="50"
                   required
                   [(ngModel)]="shipping.firstname">
        </input-wrap>
        <!-- last name -->
        <input-wrap class="m-t-3 block">
            <input class="input"
                   type="text"
                   name="lastname"
                   [muiInput]="'Last name'"
                   validatePattern="name"
                   maxlength="50"
                   required
                   [(ngModel)]="shipping.lastname">
        </input-wrap>
        <!-- newsletter signup -->
        @if (!customer.model.data.newsletter) {
        <input-wrap class="m-t-6 block">
            <p class="flex flex-middle">
                <i class="icon-email inline-block fs-8"></i>
                <span class="p1 col-1 m-l-3">{{'Sign up to our newsletter' | translate}}</span>
            </p>
            <radio-group class="radio-group block m-t p-t-1 left"
                         name="newsletter"
                         [(ngModel)]="checkoutFormComponent.data.newsletter">
                <div class="w-4 w-6-s left">
                    <radio value="1"><span class="p-l-2">{{'Yes, please' | translate}}</span></radio>
                </div>
                <div class="w-4 w-6-s left">
                    <radio [value]="undefined"><span class="p-l-2">{{'No, thanks' | translate}}</span></radio>
                </div>
            </radio-group>
        </input-wrap>
        }
        <!-- action button -->
        <action class="w-12 m-t-6 p-r-0 p-l-0 button"
                type="button"
                (click)="continueAsGuestToDelivery()">
            @if (!isVirtual) {
            <span>{{'Continue to delivery' | translate}}</span>
            }
            @if (isVirtual) {
            <span>{{'Continue to payment' | translate}}</span>
            }
        </action>
        }

        <!-- action button -->
        @if (!shouldLogin() && !shouldRegister() && checkoutStepComponent.isCurrent) {
        <action class="w-12 p-r-0 p-l-0 button"
                type="button"
                [ngClass]="{'m-t':!isValid}"
                [attr.disabled]="!isValid ? 'disabled' : null"
                [status]="checkStatus"
                (click)="goNextStep()">
            @if (!isVirtual) {
            <span>{{'Continue to delivery' | translate}}</span>
            }
            @if (isVirtual) {
            <span>{{'Continue to payment' | translate}}</span>
            }
        </action>
        }
    </ng-form>
    <ng-container *ifNotTradeStore>
        @if (!shouldLogin() && !shouldRegister() && checkoutStepComponent.isCurrent && !isLoggedIn) {
        <social-login class="block p-b"></social-login>
        }
    </ng-container>
</ng-container>


<ng-form #stepForm="ngForm">
    <!-- dummy field for step validataion for step -->
    @if (!isValid) {
    <input type="hidden"
           name="dummy"
           [(ngModel)]="dummy"
           required>
    }
</ng-form>